<template>
  <main id="page" class="w-full">
    <background-red-concrete>
      <the-loading-screen class="z-50" />

      <the-language-switcher class="fixed top-0 right-0 z-40" />
      <the-language-switcher-screen v-if="$store.state.languageScreenIsOpen" class="z-50" />

      <div id="intro_section_group" class="relative overflow-hidden">
        <section-01 @next-section="nextSection('section_02')" />
        <section-02 @next-section="nextSection" />
      </div>

      <div v-for="section of sectionList" :key="section.id" class="relative">
        <div class="py-16" :id="section.id">
          <component :is="`section-${section.type}`" :content="section" :animated="true" />
        </div>
      </div>
    </background-red-concrete>
  </main>
</template>

<script>
import TheLoadingScreen from "./loading-screen/TheLoadingScreen";
import TheLanguageSwitcher from "./language-switcher/TheLanguageSwitcher";
import TheLanguageSwitcherScreen from "./language-switcher/TheLanguageSwitcherScreen";
import Section01 from "./sections/01/Section01";
import Section02 from "./sections/02/Section02";
import SectionText from "./sections/SectionText";
import SectionTextRedirect from "./sections/SectionTextRedirect";
import SectionSound from "./sections/SectionSound";
import BackgroundRedConcrete from "./section-backgrounds/RedConcrete";

import sections from "../sections.js";

import { gsap } from "gsap";

export default {
  components: {
    TheLoadingScreen,
    TheLanguageSwitcher,
    TheLanguageSwitcherScreen,
    Section01,
    Section02,
    SectionText,
    SectionTextRedirect,
    SectionSound,
    BackgroundRedConcrete,
  },

  data() {
    return {
      sectionList: null,
    };
  },

  mounted() {
    this.sectionList = sections.home;
    this.startFromTop();
  },

  methods: {
    startFromTop() {
      setTimeout(() => {
        gsap.to(window, { scrollTo: "#section_01", duration: 0 });
      });
    },
    nextSection(sectionID = null) {
      if (sectionID) {
        gsap.to(window, { scrollTo: `#${sectionID}`, duration: 1 });
      } else {
        gsap.to(window, { scrollTo: `#${this.sectionList[0].id}`, duration: 1 });
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
</style>